/**
 * The initial values for the redux state.
 */
export const INITIAL_STATE = {
  user: {},
  token: {},
  assignmentData: {},
  assignmentDataSummary: [],
  lessonUnitDetails: [],
  currentActivity: {},
  containedActivity: {},
  currentLessonUnitDistId: undefined,
  WorkJson: "",
  containedWorkJson: "",
  exerciseList: [],
  previousExerciseList: [],
  headerTitle: "BackPack",
  loading: false,
  currentUnitName: "",
  currentCourseId: "",
  currentLessonName: "",
  fromPending: true,
  CourseAnalytics: {},
  StudentLessonpodAnalytics: {},
  StudentActivityAnalytics: {},
  fromAnalytics: false,
  fromCourse: true,
  showToastModal: false,
  toastMessageText: undefined,
  toastType: undefined,
  headerItemSelected: "home",
  navigationIndex: 0,
  currentCourseName: "",
  walkthroughStatus: false,
  selectedClass: {},
  selectedChapter: {},
  selectedFolder: {},
};
